import { render, staticRenderFns } from "./IniciativasInstitucionais.vue?vue&type=template&id=0675950c&scoped=true"
import script from "./IniciativasInstitucionais.vue?vue&type=script&lang=js"
export * from "./IniciativasInstitucionais.vue?vue&type=script&lang=js"
import style0 from "./IniciativasInstitucionais.vue?vue&type=style&index=0&id=0675950c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675950c",
  null
  
)

export default component.exports